module.exports = __webpack_public_path__ + "img/list-view.15b6e634.svg";